import { initForm } from './form'
import { initUtm } from './utm'

document.addEventListener("DOMContentLoaded", (e) => {
  document.querySelectorAll("a[href^=\"#\"]").forEach(anchor => {
    anchor.addEventListener("click", (e) => {
      e.preventDefault()

      document.querySelector(e.target.getAttribute("href")).scrollIntoView({
          behavior: "smooth"
      })
    })
  })
})

initUtm({
  form: document.querySelector('#orcamento > form'),
})

initForm({
  form: document.querySelector('#orcamento > form'),
  sendTo: 'https://crm.desbrave.com.br/api/v1/accounts/n10/leads',
  redirectTo: '/sucesso.html',
})
